export default theme => ({
  container: {
    float: "left",
    position: "absolute",
    height: "100%",
  },
  currentIndicator: {
    stroke: theme.palette.userPrimary.main,
  },
});
